export default "__VITE_ASSET__B7viE7BV__"